import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=eddc9216&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=eddc9216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddc9216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eddc9216')) {
      api.createRecord('eddc9216', component.options)
    } else {
      api.reload('eddc9216', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=eddc9216&scoped=true&", function () {
      api.rerender('eddc9216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ujazRDjZaHke/JS/comp/GuestBox.vue"
export default component.exports